<template>
    <div class="search-result">
        <div class="search-result__column" data-column="title" data-title="Title">
            <router-link :to="link" class="company">
                <img
                    :src="resource.country.flag || '//placehold.it/24x16'"
                    :alt="resource.country.name"
                    class="flag"
                    v-tippy="resource.country.name"
                />
                <span :class="{ 'name': true }" v-html="formattedTitle"/>
            </router-link>
        </div>
        <div class="search-result__column" data-column="deal_type" data-title="Deal Type">
            <span v-text="resource.deal_type" />
        </div>
        <div class="search-result__column" data-column="value" data-title="Value">
            <span v-text="resource.deal_value" />
        </div>
        <div class="search-result__column" data-column="sector" data-title="Main Sector">
            <span class="sector" v-if="sector">{{ sector.name }}</span>
        </div>
        <div class="search-result__column" data-column="completed" data-title="Completed">
            <span v-html="resource.completed_at" />
        </div>
        <div v-if="resource.found_highlights" data-column="highlights" class="search-result__column">
            <HighlightResult
                v-for="highlight in resource.found_highlights"
                :resource="highlight"
                :key="highlight.key"
            />
        </div>
    </div>
</template>
<script>
import { parse, format } from 'date-fns';
import { mapState } from 'vuex';
import HighlightResult from '@components/Search/HighlightResult.vue';

export default {
    name: 'MADDSearchResult',
    components: { HighlightResult },
    props: {
        resource: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
        formattedTitle() {
            if(this.resource.project_name === this.resource.company_name) {
                return this.resource.project_name;
            }

            if(!this.resource.project_name) {
                return this.resource.company_name;
            }

            return `${ this.resource.project_name } (${ this.resource.company_name })`;
        },
        sector() {
            if(!this.resource.sectors || !this.resource.sectors.length) {
                return '';
            }

            if(!this.user.subscribed || !this.user.subscribed.length) {
                return this.resource.sectors[0];
            }

            //Filter row sectors to ones the user is subscribed to
            let subscribed = this.user.subscribed.map(sector => sector.id),
                sectors = this.resource.sectors.filter(sector => subscribed.indexOf(sector.id) > -1);

            //Return first subscribed sector, or first row sector if none are subscribed to
            return sectors.length ? sectors[0] : this.resource.sectors[0];
        },
        link() {
            return {
                name: (this.resource.status === 2) ? 'view-madd' : 'madd-preview' ,
                params: { madd_id: this.resource.id }
            }
        },
        date() {
            return this.resource.created_at ? format(parse(this.resource.created_at), 'dd/MM/yy') : 'Unknown';
        },
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.search-result {
    display: flex;
    flex-wrap: wrap;
    row-gap: 1rem;
    align-items: center;

    .search-result__column {
        &[data-column="title"] {
            flex: 1 1 auto;
            max-width: calc((((100% - 18rem) - 18rem) - 9rem) - 10.2rem);
            font-weight: bold;
            padding-right: 1rem;

            .company {
                color: #000000;
                display: flex;
                align-items: center;

                .flag {
                    margin-right: 1rem;
                    max-width: 2.4rem;
                    height: auto;
                    flex: 0 0 auto;
                    position: relative;
                }

                .name {
                    max-width: calc(100% - 3.8rem);
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    font-size: 1.4rem;
                }
            }
        }

        &[data-column="deal_type"] {
            flex: 0 0 18rem;
        }

        &[data-column="value"] {
            flex: 0 0 9rem;
        }

        &[data-column="sector"] {
            flex: 0 0 18rem;
            display: flex;
            flex-wrap: wrap;
            gap: .5rem;

            .sector {
                margin-right: 0;
                margin-bottom: 0;
            }
        }

        &[data-column="completed"] {
            flex: 0 0 9rem;
            text-align: right;
        }

        &[data-column="highlights"] {
            flex: 1 0 100%;
            width: 100%;
        }
    }

    @media screen and (max-width: 991px) {
        row-gap: 2rem;
        align-items: flex-start;
        justify-content: space-between;

        .search-result__column {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            align-self: flex-start;
            gap: 1rem;

            &:before {
                content: attr(data-title);
                color: $text;
                font-size: 1.4rem;
                font-weight: normal;
                line-height: 1;
                display: block;
            }

            &[data-column="title"] {
                flex: 1 0 100%;
                max-width: 100%;
                padding-right: 0;

                a {
                    width: 100%;
                }
            }


            &[data-column="deal_type"],
            &[data-column="value"],
            &[data-column="sector"],
            &[data-column="completed"] {
                flex: 0 0 calc(50% - .6rem);
                gap: 1rem;

                span:not(.sector) {
                    line-height: 2rem;
                }

                .sector {
                    display: inline-flex;
                }
            }
        }
    }
}
</style>
